import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { surveyParamsResponseSchema } from "@/domains/surveys/models/schemas";

export const surveyQueryOptions = createQueryKeys("survey", {
  params: {
    queryKey: null,
    queryFn: () => {
      return getSurveyParams();
    },
  },
});

const getSurveyParams = async () => {
  const response = await privateApi.get(`/survey`);

  return createServiceResponseSchema(surveyParamsResponseSchema).parse(response.data).data;
};
